/*eslint-disable */

import { bus } from '@/main';

var $ = window.jQuery = require('jquery');
export default {
  name: 'thirty-dats-trail-popup',
  components: {},
  props: ['thirtyDaysTrailEnded'],
  data () {
    return {
      thirtyDayTrailStart:Boolean,
      isDisabled:false
    }
  },
  computed: {
  },
  mounted () {
    this.thirtyDayTrailStart = this.thirtyDaysTrailEnded
  },
  methods: {
    nextStepMethod(){
      this.isDisabled = true
      this.$store.dispatch('updateThirtyDaysTrailApiUrl').then((res) => {
        bus.$emit('thirtyDaysTrailPopupStateBus', false)
        bus.$emit('createMeetingPopupBus', true)
        this.isDisabled = false
      }).catch((err)=>{
        this.isDisabled = false
      })
    },
    closeBlurbPopupOfMeetingMethod(){
      bus.$emit('thirtyDaysTrailPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    }
  }
}